/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HealthOut
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Liveness
 */
export const healthLiveness = (
    
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<HealthOut>(
      {url: `/api/v1/health`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getHealthLivenessQueryKey = () => {
    return [
    `/api/v1/health`
    ] as const;
    }

    
export const getHealthLivenessQueryOptions = <TData = Awaited<ReturnType<typeof healthLiveness>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthLiveness>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthLivenessQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthLiveness>>> = ({ signal }) => healthLiveness(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthLiveness>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthLivenessQueryResult = NonNullable<Awaited<ReturnType<typeof healthLiveness>>>
export type HealthLivenessQueryError = ErrorType<unknown>


export function useHealthLiveness<TData = Awaited<ReturnType<typeof healthLiveness>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthLiveness>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthLiveness>>,
          TError,
          Awaited<ReturnType<typeof healthLiveness>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthLiveness<TData = Awaited<ReturnType<typeof healthLiveness>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthLiveness>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthLiveness>>,
          TError,
          Awaited<ReturnType<typeof healthLiveness>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthLiveness<TData = Awaited<ReturnType<typeof healthLiveness>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthLiveness>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Liveness
 */

export function useHealthLiveness<TData = Awaited<ReturnType<typeof healthLiveness>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthLiveness>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthLivenessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Readiness (проверка БД)
 */
export const healthReadiness = (
    
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<HealthOut>(
      {url: `/api/v1/health/ready`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getHealthReadinessQueryKey = () => {
    return [
    `/api/v1/health/ready`
    ] as const;
    }

    
export const getHealthReadinessQueryOptions = <TData = Awaited<ReturnType<typeof healthReadiness>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthReadiness>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthReadinessQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthReadiness>>> = ({ signal }) => healthReadiness(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthReadiness>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthReadinessQueryResult = NonNullable<Awaited<ReturnType<typeof healthReadiness>>>
export type HealthReadinessQueryError = ErrorType<void>


export function useHealthReadiness<TData = Awaited<ReturnType<typeof healthReadiness>>, TError = ErrorType<void>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthReadiness>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthReadiness>>,
          TError,
          Awaited<ReturnType<typeof healthReadiness>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthReadiness<TData = Awaited<ReturnType<typeof healthReadiness>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthReadiness>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthReadiness>>,
          TError,
          Awaited<ReturnType<typeof healthReadiness>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthReadiness<TData = Awaited<ReturnType<typeof healthReadiness>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthReadiness>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Readiness (проверка БД)
 */

export function useHealthReadiness<TData = Awaited<ReturnType<typeof healthReadiness>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthReadiness>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthReadinessQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




